<template>
  <div class="ts-toolbar">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.ts-toolbar {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  box-shadow: 5px 5px 10px 0 rgba(166, 171, 189, 0.48);
  border-radius: 32px;

  margin: -2px;
  padding: 24px 40px;
  // min-height: 64px;
  z-index: 1;
}
</style>

<script>
export default {
  name: 'TsToolbar'
};
</script>
